import React, { useState, useEffect } from 'react';
import './AdminNav.css';

export default function AdminNav({ currentPage, onPageChange, onLogout, user }) {
  const [counts, setCounts] = useState({
    caseStudies: 0,
    clients: 0,
    testimonials: 0,
    enquiries: 0
  });

  useEffect(() => {
    const fetchCounts = async () => {
      try {
        const token = localStorage.getItem('token');
        const headers = { 'Content-Type': 'application/json' };
        if (token) headers['Authorization'] = `Bearer ${token}`;

        const [caseStudiesRes, clientsRes, testiRes, enquiriesRes] = await Promise.all([
          fetch('/api/case-studies', { headers }),
          fetch('/api/clients', { headers }),
          fetch('/api/testimonials', { headers }),
          fetch('/api/enquiries', { headers })
        ]);

        const caseStudiesData = await caseStudiesRes.json();
        const clientsData = await clientsRes.json();
        const testiData = await testiRes.json();
        const enquiriesData = await enquiriesRes.json();

        setCounts({
          caseStudies: Array.isArray(caseStudiesData) ? caseStudiesData.length : 0,
          clients: Array.isArray(clientsData) ? clientsData.length : 0,
          testimonials: Array.isArray(testiData) ? testiData.length : 0,
          enquiries: Array.isArray(enquiriesData) ? enquiriesData.length : 0
        });
      } catch (err) {
        console.error('Error fetching counts:', err);
      }
    };

    fetchCounts();
  }, []);

  const navGroups = [
    {
      group: 'Manage',
      items: [
        { id: 'overview', label: 'Overview', icon: '▤' },
        { id: 'case-studies', label: 'Case studies', icon: '◫', count: counts.caseStudies },
        { id: 'clients', label: 'Clients & logos', icon: '◊', count: counts.clients },
        { id: 'testimonials', label: 'Testimonials', icon: '¶', count: counts.testimonials }
      ]
    },
    {
      group: 'Operations',
      items: [
        { id: 'enquiries', label: 'Enquiries', icon: '✉', count: counts.enquiries, dot: true },
        { id: 'team', label: 'Team & roles', icon: '◐' }
      ]
    },
    {
      group: 'System',
      items: [
        { id: 'settings', label: 'Settings', icon: '⚙' }
      ]
    }
  ];

  return (
    <nav className="admin-sidebar">
      <div className="admin-brand" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <img
          src="https://k-capital-technologies.s3.ap-southeast-2.amazonaws.com/logos/KCapitalLogo.png"
          alt="K Capital Technology"
          style={{ height: '40px', width: 'auto' }}
        />
        <div className="admin-brand-name" style={{ lineHeight: '1.1' }}>
          <strong>K Capital Technologies</strong>
          <span>Admin · v.04.26</span>
        </div>
      </div>

      <nav className="admin-nav">
        {navGroups.map((group, idx) => (
          <div key={idx}>
            <div className="admin-nav__group">{group.group}</div>
            {group.items.map(item => (
              <button
                key={item.id}
                className={`admin-nav__item ${currentPage === item.id ? 'is-active' : ''}`}
                onClick={() => onPageChange(item.id)}
              >
                <span className="admin-nav__icon">{item.icon}</span>
                <span>{item.label}</span>
                {item.count && <span className="admin-nav__count">{item.count}</span>}
                {item.dot && <span className="admin-nav__pulse"></span>}
              </button>
            ))}
          </div>
        ))}
      </nav>

      <div className="admin-user">
        <div className="admin-user__avatar">
          {user?.name ? user.name.split(' ').map(n => n[0]).join('').toUpperCase() : '?'}
        </div>
        <div>
          <div className="admin-user__name">{user?.name || 'User'}</div>
          <div className="admin-user__role">{user?.role ? user.role.charAt(0).toUpperCase() + user.role.slice(1) : 'No role'}</div>
        </div>
        <button className="admin-user__menu" onClick={onLogout} title="Sign Out">
          ⋯
        </button>
      </div>
    </nav>
  );
}
